import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class MessageGuy extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.character = null;
    this.msgContainer = null;
    this.msgBubble = null;
    this.lblMsg = null;

    this.font = null;

    this.character = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._ClamTalker, this).setOrigin(0);

    this.msgContainer = this.scene.add.container();
    this.add(this.msgContainer);
    this.msgBubble = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._ClamSpeechBubble, this.msgContainer).setOrigin(0);

    this.font = FontKeys._bpreplaybold;
    this.lblMsg = ABCyaPhaser.Text.addText(this.msgBubble.width / 2,0, 32, 0x006699, this.font, ABCyaPhaser.Localization.instance.getLocalizedString('clam_default'), this.msgContainer, true).setOrigin(0.5);

    this.character.x = this.msgBubble.width - 85;
    this.character.y = this.msgBubble.height - 50;

    this.lblMsg.y = this.msgBubble.height / 2 - this.lblMsg.height + 10;

    this.msgContainer.alpha = 0;
  }

  showMessage (value,newFontSize,stay, waitTime) {
    this.msgContainer.alpha = 0;
    if (newFontSize) this.lblMsg.setFontSize(newFontSize);
    // eslint-disable-next-line no-param-reassign
    if (!waitTime) waitTime = 1200;
    this.lblMsg.text = value;

    this.scene.tweens.killTweensOf(this.msgContainer);
    ABCyaPhaser.Tweens.addTween(this.msgContainer, 440, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
      if (!stay) ABCyaPhaser.Tweens.addTween(this.msgContainer, 440, { delay: waitTime, alpha: 0 }, Phaser.Math.Easing.Quadratic.In);
    });
  }
}